import mobile from 'is-mobile';
import { inject } from 'vue';

import { defineAppPlugin } from '@/main';

export default defineAppPlugin(({ app }) => {
  app.provide('isMobile', mobile({ tablet: true }));
});

export function useIsMobile() {
  return inject('isMobile', false);
}
